/* eslint-disable import/prefer-default-export */

export const getExperimentVariation = (experimentName) => (state) =>
  state.experimentVariations[experimentName] || null;

export const getExperimentVariationSetter = (state) =>
  state.setExperimentVariations;
